<!-- <p-toast></p-toast> -->
<main class="main users chart-page card card-body" id="skip-target">
  <div class="container-fluid cardone">
    <p-toast position="center" key="c" [baseZIndex]="5000">

    </p-toast>
    <!-- <p class="stat-cards-info__title title">Excursion</p> -->
    <h2 class="main-title">Excursion</h2>
    <form #formRow [formGroup]="excursionForm" (ngSubmit)="excursion_serarch_FormSubmit(false)">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Excursion From:</label>
          </div>
          <div class="col-12 ">

            <p-calendar #theCalendar [readonlyInput]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
              dateFormat="dd-m-yy" formControlName="excursion_from_date"></p-calendar>
            <!-- <input type="text" formControlName="name" id="name" class="form-input" placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Excursion To:</label>
          </div>
          <div class="col-12 ">
            <p-calendar autofocus="true" [readonlyInput]="true" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy" formControlName="excursion_to_date"></p-calendar>
            <!-- <input type="text" formControlName="request_date_to" id="name" class="form-input" placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Request From Date</label>
          </div>
          <div class="col-12 ">
            <p-calendar [style]="{'width':'100%'}" [readonlyInput]="true" [inputStyle]="{'width':'100%'}"
              dateFormat="dd-m-yy" formControlName="request_from_date"></p-calendar>
            <!-- <input type="text" formControlName="transfer_date_from" id="name" class="form-input" placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Request To Date</label>
          </div>
          <div class="col-12 ">
            <p-calendar [style]="{'width':'100%'}" [readonlyInput]="true" [inputStyle]="{'width':'100%'}"
              dateFormat="dd-m-yy" formControlName="request_to_date"></p-calendar>
            <!-- <input type="text" formControlName="transfer_date_to" id="name" class="form-input" placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12">
            <label class="form-label" for="name">Priority</label>
          </div>
          <div class="col-12">
            <ng-select [searchable]="false" formControlName="priority">
              <ng-option *ngFor="let pr of prioritylist" [value]="pr.priority_id">{{pr.priority_name}}</ng-option>

            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12">
            <label class="form-label" for="name">Supplier</label>
          </div>
          <div class="col-12">
            <ng-select [searchable]="true" formControlName="Supplier">
              <ng-option *ngFor="let pr of supplier_list" [value]="pr.partycode">{{pr.partyname}}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="col-12">
            <label class="form-label" for="name">Excursion Classification</label>
          </div>
          <div class="col-12">
            <ng-select [items]="classificationlist" [searchable]="true" [multiple]="true"
              [closeOnSelect]="false" [selectableGroup]="true" [selectableGroupAsModel]="false" groupBy="selectedAllGroup"
              bindValue="classificationcode" bindLabel="classificationname"
              formControlName="excursion_classification">
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone : true }" /> Select All
              </ng-template> 
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected"
                  [ngModelOptions]="{ standalone : true }" /> {{item.classificationname}}
              </ng-template>
              <!-- <ng-option *ngFor="let cl of classificationlist" [value]="cl.classificationcode">
                <span [title]="cl.classificationname">{{cl.classificationname}}</span>
              </ng-option> -->
            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Hotel Name/Pickup Location</label>
          </div>
          <div class="col-12 ">
            <span style="width: 100%;" class="p-input-icon-right">
              <ng-select (keyup)="searchlocation_pickup($event.target)" [items]="locatin_pickup" bindLabel="LOCATION"
                bindValue="LOCATION" formControlName="excursion_pickuplocation">
                <ng-template ng-option-tmp let-item="item">
                  <div title="{{item.LOCATION}}">{{item.LOCATION}}</div>
                </ng-template>
              </ng-select>
              <!-- <ng-autocomplete 
                  formControlName="excursion_pickuplocation"
                    [data]="locations"
                    [searchKeyword]="keyword"
                    (keyup)="searchlocation($event.target)"
                    historyIdentifier="locations"
                    placeholder="Select country"
                    (selected)='selectEvent($event)'
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate">                                 
                  </ng-autocomplete>
                  
                  <ng-template #itemTemplate let-item>
                  <a  [innerHTML]="item.partyname"></a>
                  </ng-template>
                  
                  <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                  </ng-template> -->



              <!-- <p-dropdown [options]="locations"  (keyup)="searchlocation($event.target)"  formControlName="excursion_pickuplocation" optionValue="partycode"  [editable]="true" optionLabel="partyname"></p-dropdown> -->
              <!-- <p-dropdown [options]="countries" (keyup)="searchlocation($event.target)"  formControlName="excursion_pickuplocation" optionLabel="name" [filter]="true" filterBy="name" [showClear]="true" placeholder="Select a Country"></p-dropdown> -->
              <!-- <input style="width: 100%;" type="text"  class="p-input-icon-right" pInputText placeholder="Search" /> -->
              <!-- <i class="pi pi-search"></i> -->
            </span>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Order By</label>
          </div>
          <div class="col-12 ">
            <ng-select [searchable]="true" [items]="orderbylist" bindLabel="value" bindValue="id"
              formControlName="order_by">
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.value}}">{{item.value}}</div>
              </ng-template>
            </ng-select>
            <!-- <ng-select formControlName="priority">
                <ng-option *ngFor="let priority of prioritylist" [value]="priority.priority_id">{{priority.priority_name}}</ng-option>
             </ng-select> -->
            <!-- <input type="text" formControlName="priority" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Excursion Types</label>
          </div>
          <div class="col-12 ">
            <ng-select placeholder="select Excursion Type" [searchable]="true" formControlName="excursion_types">
              <ng-option *ngFor="let ex of excursion_typeslist" title="{{ex.exctypname}}" [value]="ex.exctypcode">

                <span [title]="ex.exctypname">{{ex.exctypname}}</span>
              </ng-option>

            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Bussines Unit</label>
          </div>
          <div class="col-12 ">
            <ng-select [searchable]="true" formControlName="bussinessunit">
              <ng-option *ngFor="let ex of bussiness_list" title="{{ex.UnitName}}" [value]="ex.UnitCode">

                <span [title]="ex.UnitName">{{ex.UnitName}}</span>
              </ng-option>

            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
      </div>
      <div class="row">
        
        

        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Status</label>
          </div>
          <div class="col-12 ">
            <ng-select [searchable]="true" formControlName="status">
              <ng-option *ngFor="let st of statuslist" [value]="st.id">{{st.value}}</ng-option>
            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name">Amendment</label>
          </div>
          <div class="col-12 ">
            <ng-select formControlName="amendment">
              <ng-option *ngFor="let ame of amendlist" [value]="ame.id">{{ame.value}}</ng-option>
            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12 offset-md-2">
          <div class="col-12 ">
            <label class="form-label" for="name">Search In</label>
          </div>
          <div class="col-12 ">
            <ng-select formControlName="sel_search_type">
              <ng-option *ngFor="let se of search_in" [value]="se.id">{{se.value}}</ng-option>
            </ng-select>
            <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="col-12 ">
            <label class="form-label" for="name">Search Keyword</label>
          </div>
          <div class="col-10 ">
            <div class="p-inputgroup">

              <input type="text" formControlName="searchkeyword" pInputText placeholder="Keyword">
              <button type="button" (click)="searchkeyword()" class="primary-default-btn" pButton pRipple
                label="Search"></button>
              <button type="button" [disabled]="referesh_btn"
                [ngStyle]="{'background-color': referesh_btn==false ? '#236ab1d9' : 'rgb(166 189 214)' }"
                (click)="refresh()" style="background-color: #9e9e9e;margin-left: 10px !important;"
                class="primary-default-btn">Refresh</button>
            </div>

            <!-- <span style="width: 100%;" class="p-input-icon-right">
                    
                    <input style="width: 100%;"  type="text" class="p-input-icon-right" pInputText placeholder="Search" />
                    <i class="pi pi-search"></i>
                </span> -->
            <!-- <input type="button" formControlName="name" id="name" class="form-btn" placeholder="Name" required > -->
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name"><br></label>
          </div>
          <div class="col-12 ">
            <button type="submit" class="primary-default-btn">Search</button>
            <!-- <input type="button" formControlName="name" id="name" class="form-btn" placeholder="Name" required > -->
          </div>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
          <div class="col-12 ">
            <label class="form-label" for="name"><br></label>
          </div>
          <div class="col-12 ">
            <button type="button" (click)="reset()" style="background-color: #9e9e9e"
              class="primary-default-btn">Clear</button>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 lgdis"></div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 lgdis"></div>
        




        <!-- <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" [disabled]="referesh_btn" [ngStyle]="{'background-color': referesh_btn==false ? '#236ab1d9' : 'rgb(166 189 214)' }" (click)="refresh()" style="background-color: #9e9e9e;margin-right: 0px !important;" class="primary-default-btn">Refresh</button>
            </div>
          </div> -->
      </div>
      <!-- <div class="container text-center">
          <div class="row">
            <div class="col-md-4">.col-md-4</div>
            <div class="col-md-4 offset-md-4">.col-md-4 .offset-md-4</div>
          </div>
          </div> -->
      <!-- <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" style="background-color: #9e9e9e" class="primary-default-btn">Reset</button>
            </div>
          </div> -->


      <div class="row">
        <br>
      </div>
    </form>
    <div class="row cardone">
      <p-scrollPanel style="width: 100%; height: 70vh;padding: 5px;">
        <div style="width: 100%;" class="card table-responsive">

          <p-table responsiveLayout="stack" (onPage)="onExcursionPageChange($event)" [value]="excursionlist"
            styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
            [(first)]="excursionPageIndex" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,20,50]">
            <ng-template *ngIf="this.appClient == 'RoyalPark'" pTemplate="caption">
              <div class="flex">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="excursionExcelExport()" class="p-button-success mr-2" pTooltip="XLSX" tooltipPosition="bottom"></button>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>Request Id</th>
                <th *ngIf="this.appClient != 'RoyalPark'">Bussines Unit</th>
                <!-- <th [title]="'adult:'+this.ex_total_adult+',child:'+this.ex_total_child+',Units:'+this.ex_total_unit">
                  No Of Guest</th> -->
                <th>Guest Name</th>

                <th *ngIf="this.appClient == 'RoyalPark'">Agent Name</th>
                <th *ngIf="this.appClient == 'RoyalPark'">RO Name</th>

                <th>Excursion Date</th>
                <th>Excursion Name</th>

                <th *ngIf="this.appClient != 'RoyalPark'">Room no</th>
                <th [title]="'Adult:'+this.ex_total_adult+',Child:'+this.ex_total_child">Adult & Child</th>
                <th [title]="'Unit:'+this.ex_total_unit">Units</th>
                
                <!-- <th>Team Member</th> -->
                <th>Hotel Name/PickUp Location</th>
                <th>Supplier Name</th>
                <!-- <th>Classification</th> -->
                <!-- <th>Status</th> -->
                <th *ngIf="this.appClient != 'RoyalPark'">Pending Amount Guest</th>
                <!-- <th>Pending Amount Approval</th> -->
                
                <th style="width: 50px;">Remarks</th>
                <th *ngIf="this.appClient == 'RoyalPark'">Exc.Status</th>
                <th *ngIf="this.appClient == 'RoyalPark'">Conf No</th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-columns="columns">
              <tr style="max-height: 30px;" [ngClass]="getExcursionRowClass(product)"> <!-- [ngClass]="{'pink_row': product.service_status=='1'}"  -->
                <td><span class="p-column-title">Request Id</span><a (click)="showCopyDetails(product)" style="color: blue;text-decoration: underline;cursor: pointer;">{{product.requestid}}</a></td>
                <td *ngIf="this.appClient != 'RoyalPark'"><span class="p-column-title">Bussinesunit</span>{{product.bussinesunitname}}</td>
                <!-- <td><span class="p-column-title">No Guest</span>Adult:{{product.adults}},Child:{{product.child}}
                  Units:{{product.units}}</td> -->
                <td><span class="p-column-title">Guest Name</span>{{product.guestname}}</td>

                <td *ngIf="this.appClient == 'RoyalPark'">{{product.agentname}}</td>
                <td *ngIf="this.appClient == 'RoyalPark'">{{product.adduser}}</td>

                <td><span class="p-column-title">Service Date</span>{{product.excdate | date: 'dd-MM-yyyy'}}</td>
                <td><span class="p-column-title">Service Name</span>{{product.servicelist}}</td>

                <td *ngIf="this.appClient != 'RoyalPark'"><span class="p-column-title">Room No</span>{{product.roomno}}</td>
                <td><span class="p-column-title">Adult & Child</span>Adult:{{product.adults}},Child:{{product.child}}
                  <span *ngIf="this.appClient=='RoyalPark' && product.childages != ''"> ({{product.childages}})  </span>
                </td>
                <td><span class="p-column-title">Units</span>Unit:{{product.units}}</td>
                
                <!-- <td><span class="p-column-title">Team Member</span>{{product.team_member}}</td> -->
                <td><span class="p-column-title">Hotel Name/PickUp Location</span>{{product.Location}}</td>
                <td><span class="p-column-title">Suppliers</span>{{product.supplier}}</td>
                <!-- <td><span class="p-column-title">Classification</span>{{product.classificationname}}</td> -->
                <!-- <td ><span class="p-column-title">Status</span>
                  {{product.service_status=='1'?'pending':product.service_status=='2'?'Assigned':product.service_status=='3'?'Confirmed':
                    product.service_status=='4'?'Cancelled':'Rejected'}}</td> -->
                <td *ngIf="this.appClient != 'RoyalPark'"><span class="p-column-title">GuestAmount</span>{{product.BalanceAmt}}</td>
                <!-- <td><span class="p-column-title">Approval Amount</span>{{product.PendingApprovalAmount}}</td> -->
                
                <td><span class="p-column-title">Remarks</span>
                  <div style="text-overflow: ellipsis;
                              max-width: 150px;
                              white-space: nowrap;
                              overflow: hidden; display:inline-block;" #container>
                    <span style="text-overflow: ellipsis;
                              max-width: 150px;" [title]="product.agentremarks">
                      {{product.agentremarks}}
                    </span>
                  </div>
                  <!-- <span >{{product.agentremarks}}</span></td> -->
                <td *ngIf="this.appClient == 'RoyalPark'">{{getServiceStatus(product.service_status)}}</td>
                <td *ngIf="this.appClient == 'RoyalPark'">{{product.ConfNo}}</td>
                <td *ngIf="product.service_status!='1'" [title]="product.actiontooltip">
                  <span class="p-column-title">Action</span>
                  <button (click)="viewdetails(product)" class="primary-default-btn"><i class="pi pi-pencil"
                      style="color:#ffffff;"></i></button>
                </td>
                <td *ngIf="product.service_status=='1'" [title]="product.actiontooltip">
                  <span class="p-column-title">Action</span>
                  <button (click)="viewdetails(product)" class="primary-default-btn"><i class="pi pi-eye"
                      style="color:#ffffff;"></i></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-scrollPanel>
    </div>
    <div class="row">
      <p-dialog (onHide)="cancel()" responsiveLayout="scroll" header="Excursion Detalis" [(visible)]="displayPosition"
        [modal]="true" [style]="{width: '95%'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
        <div class="row">
          <div *ngIf="this.excursiondeails.length!=0" style="width: 100%;" class="card">
            <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>

            <div class="row">
              <div class="col-lg-3  col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Request_id:</label><span>
                    {{this.excursiondeails.requestid}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Request_date:</label><span>
                    {{this.excursiondeails.requestdate}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Agent Name:</label><span>
                    {{this.excursiondeails.agentname}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Agent Ref No:</label><span>
                    {{this.excursiondeails.agentref }}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Booking Created By:</label><span>
                    {{this.excursiondeails.created_by}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Row No:</label><span>
                    {{this.excursiondeails.elineno}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Price Type:</label><span>
                    {{this.excursiondeails.ratebasis}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Single/Multicost:</label><span>
                    {{this.excursiondeails.is_multicost==0?'single':'multicost'}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Total Pax:</label><span>
                    {{this.excursiondeails.adults+this.excursiondeails.child+this.excursiondeails.senior}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Pax:</label><span>
                    adult:{{this.excursiondeails.adults}},child:{{this.excursiondeails.child}}
                    <span *ngIf="this.appClient == 'RoyalPark' && this.excursiondeails.childages != ''"> ({{this.excursiondeails.childages}})  </span>
                    <span *ngIf="this.appClient != 'RoyalPark'">,senior:{{this.excursiondeails.senior}}</span>
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Free Child:</label><span>
                    {{this.excursiondeails.supplierList[0].childasfree==undefined?0:this.excursiondeails.supplierList[0].childasfree}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <!-- <label class="form-label" for="name">Total Sale Price:</label> -->
                  <label class="form-label" for="name">Line Booking Sale : </label>
                  <span *ngIf="this.appClient=='RoyalPark'" > ({{this.excursiondeails.sellingCurrency}}) </span>
                  <span>
                    <!-- {{this.excursiondeails.totalsalevalue | number:'1.2-2'}} -->
                    {{this.excursiondeails.maxtotalsalevalue | number:'1.2-2'}}
                  </span>
                </div>
              </div>
              <div *ngIf="this.appClient == 'RoyalPark' && (this.excursiondeails.sellingCurrency != this.excursiondeails.baseCurrency)" class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <!-- <label class="form-label" for="name">Total Sale Price:</label> -->
                  <label class="form-label" for="name">Line Booking Sale : </label>
                  <span *ngIf="this.appClient=='RoyalPark'" > ({{this.excursiondeails.baseCurrency}}) </span>
                  <span>
                    <!-- {{this.excursiondeails.totalsalevalue | number:'1.2-2'}} -->
                    {{this.excursiondeails.baseCurrtotalsalevalue | number:'1.2-2'}}
                  </span>
                </div>
              </div>
              <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name">Max Sale Price:</label><span>
                    {{this.excursiondeails.maxtotalsalevalue | number:'1.2-2'}}
                  </span>
                </div>

              </div> -->
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <!-- <label class="form-label" for="name">Total Cost Price:</label> -->
                  <label class="form-label" for="name">Line Booking Cost : </label>
                  <span *ngIf="this.appClient=='RoyalPark'" > ({{this.excursiondeails.baseCurrency}}) </span>
                  <span>
                    {{this.excursiondeails.totalcostvalue | number:'1.2-2'}}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <!-- <label class="form-label" for="name">Profit:</label> -->
                  <label class="form-label" for="name">Line Booking Profit : </label>
                  <span *ngIf="this.appClient == 'RoyalPark'" > ({{this.excursiondeails.baseCurrency}}) </span>
                  <span *ngIf="this.appClient == 'RoyalPark' && this.excursiondeails.comp_cust == 0">
                    <!-- {{this.excursiondeails.totalsalevalue-this.excursiondeails.totalcostvalue | number:'1.2-2' }} -->
                    <!-- {{this.excursiondeails.maxtotalsalevalue-this.excursiondeails.totalcostvalue | number:'1.2-2' }} -->
                    {{this.excursiondeails.baseCurrtotalsalevalue-this.excursiondeails.totalcostvalue | number:'1.2-2' }}
                  </span>
                  <span *ngIf="this.appClient == 'RoyalPark' && this.excursiondeails.comp_cust == 1">
                    {{0 | number:'1.2-2'}}
                  </span>
                  <span *ngIf="this.appClient != 'RoyalPark'">
                    {{this.excursiondeails.maxtotalsalevalue-this.excursiondeails.totalcostvalue | number:'1.2-2' }}
                  </span>
                </div>

              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <!-- <label class="form-label" for="name">Markup%:</label> -->
                  <label class="form-label" for="name">Line Booking Profit% : </label>
                  <span *ngIf="this.appClient == 'RoyalPark' && this.excursiondeails.comp_cust == 0">
                    <!-- {{this.excursiondeails.totalsalevalue-this.excursiondeails.totalcostvalue | number:'1.2-2'}} -->
                    {{(this.excursiondeails.baseCurrtotalsalevalue-this.excursiondeails.totalcostvalue) / this.excursiondeails.totalcostvalue * 100 | number:'1.2-2'}}
                  </span>
                  <span *ngIf="this.appClient == 'RoyalPark' && this.excursiondeails.comp_cust == 1">
                    {{0 | number:'1.2-2'}}
                  </span>
                  <span *ngIf="this.appClient != 'RoyalPark'">
                    {{(this.excursiondeails.maxtotalsalevalue-this.excursiondeails.totalcostvalue) / this.excursiondeails.totalcostvalue * 100 | number:'1.2-2'}}
                  </span>
                </div>

              </div>
              <div *ngIf="this.appClient != 'RoyalPark'" class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="col-12" style="padding-top: 4px;">
                  <a (click)="showPricePopup()"
                    style="color: #2196F3;text-decoration: underline;font-style: italic;cursor: pointer;">Click here to
                    view overall Cost info</a>
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <p-table *ngIf="menutitle=='supplier'" #dt scrollHeight="50vh" dataKey="service_id"
                [value]="excursiondeails.supplierList" [loading]="loading" styleClass="p-datatable-striped"
                responsiveLayout="stack" rowExpandMode="single" [expandedRowKeys]="expandedRows">
                <!-- <ng-template pTemplate="caption">
                  Default
              </ng-template> -->
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <!-- <th>Critical</th> -->
                    <th style="width: 3rem"></th>
                    <th>Service Date</th>
                    <th>Service Type</th>
                    <th style="max-width: 100px;">Supplier</th>
                    <th>Total Adult </th>
                    <th>Total Child</th>
                    <th *ngIf="this.appClient != 'RoyalPark'">Total Senior</th>
                    <th *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')">Cost/Adult</th>
                    <th *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')">Cost/child</th>
                    <th *ngIf="this.appClient != 'RoyalPark' && (cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')">Cost/senior</th>
                    <th *ngIf="excursiondeails.ratebasis=='UNIT'">Units</th>
                    <th *ngIf="excursiondeails.ratebasis=='UNIT'">Unit Price</th>
                    <!-- <th>Comp</th> -->
                    <!-- <th>Status</th> -->
                    <!-- <th>Supplier remarks</th> -->
                    <th>Total</th>
                    <!-- excursiondeails.ratebasis!='UNIT' condition added by Ram 10-07-2023 -->
                    <!-- this.excursiondeails.is_multidate == 0 condition added by Ram 30-05-2024 -->
                    <th style="width: 20px"
                      *ngIf="this.excursiondeails.is_multicost==0 && this.excursiondeails.is_multidate == 0 && excursiondeails.ratebasis!='UNIT' ">Add More
                      supplier</th>

                    <th colspan="2">Actions</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-product let-rowData let-columns="columns"
                  let-expanded="expanded">
                  <!-- {{this.excursiondeails.is_multicost}} -->
                  <tr
                    *ngIf="((this.excursiondeails.supplierList.length>0 && this.excursiondeails.is_multicost==0) || product.is_parent!=1 || (this.excursiondeails.supplierList.length==1 && this.excursiondeails.is_multicost==1))">
                    <!-- {{this.excursiondeails.supplierList.length}} {{product.is_parent }} -->
                    <td>
                      <button type="button" pButton pRipple [pRowToggler]="product"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>{{excursiondeails.supplierList[rowIndex].excdate}}</td>
                    <td>{{product.sm_name}}</td>

                    <td style="min-width: 180px;"
                      [pEditableColumn]="excursiondeails.supplierList[rowIndex]['partycode']"
                      pEditableColumnField="rowData['partycode']">
                      <!-- <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-dropdown [options]="supplier_list" [(ngModel)]="product.inventoryStatus" [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <p-dropdown [options]="supplier_list" [ngModel]="product.inventoryStatus" [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                    </p-cellEditor> -->
                      <!-- <p-cellEditor>
                              <ng-template pTemplate="input"> -->
                      <!-- <ng-select   [style]="{'width':'251px'}"  [items]="supplier_list" bindLabel="partyname" bindValue="partycode"  (ngModel)="excursiondeails.supplierList[rowIndex].partycode">
                                  <ng-template ng-option-tmp let-item="item">
                                    <div title="{{item.partyname}}">{{item.partyname}}</div>
                                    </ng-template>
                                </ng-select> -->
                      <!-- <p-dropdown  [options]="supplier_list" [style]="{'width':'100%'}"  (onChange)="onSampleChange($event)"    optionLabel="partyname" optionValue="partycode" placeholder="Select a Supplier">
                              </p-dropdown> -->
                      <!-- </ng-template>
                              <ng-template pTemplate="output">
                                <ng-select [style]="{'width':'251px'}"  [items]="supplier_list" bindLabel="partyname" bindValue="partycode"  [ngModel]="excursiondeails.supplierList[rowIndex].partycode">
                                  <ng-template ng-option-tmp let-item="item">
                                    <div title="{{item.partyname}}">{{item.partyname}}</div>
                                    </ng-template>
                                </ng-select> -->
                      <!-- <ng-template pTemplate="input"> -->
                      <!-- <p-dropdown  [options]="supplier_list" [style]="{'width':'100%'}"  optionLabel="partyname" optionValue="partycode" [filter]="true" filterBy="partyname" [showClear]="true" placeholder="Select a Supplier">
                                    {{excursiondeails.supplierList[rowIndex]['partycode']}}
                                  </p-dropdown> -->
                      <ng-select [style]="{'width':'250px'}" [searchable]="true" [items]="supplier_list"
                        bindLabel="partyname" bindValue="partycode"
                        (click)="supplierOnClick($event,rowIndex,excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType:'Adult')"
                        (change)="supplieronChangevalue($event,rowIndex,excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType:'Adult')"
                        (clear)="resetsupplier(rowIndex);"
                        (close)="closedropdown(rowIndex,excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType:'Adult')"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex].partycode">

                        <ng-template ng-option-tmp let-item="item">
                          <div title="{{item.partyname}}">{{item.partyname}}</div>
                        </ng-template>
                      </ng-select>
                      <!-- <ng-select *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType=='Child':false" [style]="{'width':'250px'}" 
    disabled="true"
    [searchable]="true"
    [items]="supplier_list"
    bindLabel="partyname"
    bindValue="partycode"
    (change)="supplieronChangevalue($event,rowIndex)"
    (clear)="resetsupplier(rowIndex);"
    [(ngModel)]="excursiondeails.supplierList[rowIndex].partycode"                             
    >
    <ng-template ng-option-tmp let-item="item">
      <div title="{{item.partyname}}">{{item.partyname}}</div>
      </ng-template>
</ng-select> -->
                      <!-- </ng-template>
                                <ng-template pTemplate="output">
                                  <p-dropdown  [options]="supplier_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex].partycode" optionLabel="partyname" optionValue="partycode" [filter]="true" filterBy="partyname" [showClear]="true" placeholder="Select a Supplier">
                                  </p-dropdown>
                                </ng-template> -->


                      <!-- </ng-template>
                          </p-cellEditor> -->

                    </td>


                    <td
                      *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length>=0)"
                      [pEditableColumn]="excursiondeails.supplierList[rowIndex].adults" pEditableColumnField="adults">
                      <!-- {{rowIndex}} -->
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let adx=index">
                        <ng-template *ngIf="li.paxType=='Adult'" pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" (keypress)="numbersOnly($event)"
                            [disabled]="excursiondeails.is_multicost==1"
                            (input)="countchange($event.target,adx,rowIndex,'Adult')" pInputText type="text"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Adult'?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].adults">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Adult'" pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text"
                            [disabled]="excursiondeails.is_multicost==1"
                            (input)="countchange($event.target,adx,rowIndex,'Adult')"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Adult'?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].adults">
                        </ng-template>
                      </p-cellEditor>

                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].adults">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].adults">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !excursiondeails.supplierList[rowIndex].cost_adult"
                        (input)="countchange($event.target,0,rowIndex,'Adult')" disabled="true"
                        style="width: 50px;border: 1px solid;"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex].adults" pOutputText type="text">
                    </td>
                    <!-- <td style="text-align: center;" *ngIf="this.excursiondeails.is_multicost!=0">
                      <input  style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].adults">
                    </td> -->
                    <!-- <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                              <input pInputText type="text" [(ngModel)]="product.adults">
                          </ng-template>
                          <ng-template pTemplate="output">
                              {{product.adults}}
                          </ng-template>
                      </p-cellEditor>
                        {{product.adults}}</td> -->
                    <td
                      *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length>=0)"
                      [pEditableColumn]="product.child" pEditableColumnField="child">
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let adx=index">
                        <ng-template *ngIf="li.paxType=='Child' || li.paxType == 'Child as Adult'" pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" (keypress)="numbersOnly($event)" disabled="true"
                            pInputText type="text" (input)="countchange($event.target,adx,rowIndex,'Child')"
                            [ngModel]="(excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Child' || excursiondeails.supplierList[rowIndex].cost[adx].paxType == 'Child as Adult')?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].child">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Child' || li.paxType == 'Child as Adult'" pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text" disabled="true"
                            (input)="countchange($event.target,adx,rowIndex,'Child')"
                            [ngModel]="(excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Child' || excursiondeails.supplierList[rowIndex].cost[adx].paxType == 'Child as Adult')?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].child">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" pInputText type="text"
                            [disabled]="excursiondeails.is_multicost==1"
                            (input)="countchange($event.target,0,rowIndex,'Child')"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].child">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text"
                            [disabled]="excursiondeails.is_multicost==1"
                            (input)="countchange($event.target,0,rowIndex,'Child')"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].child">
                        </ng-template>
                      </p-cellEditor>

                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !excursiondeails.supplierList[rowIndex].cost_child"
                        style="width: 50px;border: 1px solid;" (input)="countchange($event.target,0,rowIndex,'Child')"
                        disabled="true" [(ngModel)]="excursiondeails.supplierList[rowIndex].child" pOutputText
                        type="text">

                    </td>
                    <!-- <td style="text-align: center;"  *ngIf="this.excursiondeails.is_multicost!=0">
                        <input style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].child">
                        </td> -->
                    <td
                      *ngIf="this.appClient != 'RoyalPark' && ((cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length>=0))"
                      [pEditableColumn]="product.senior" pEditableColumnField="senior">
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let adx=index">
                        <ng-template *ngIf="li.paxType=='senior'" pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" (keypress)="numbersOnly($event)"
                            (input)="countchange($event.target,adx,rowIndex,'senior')"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Senior'?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].senior"
                            pInputText type="text">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='senior'" pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Adult'?excursiondeails.supplierList[rowIndex].cost[adx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].senior">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 50px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].senior">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 50px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].senior">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !excursiondeails.supplierList[rowIndex].cost_senior"
                        style="width: 50px;border: 1px solid;"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex].senior" disabled="true" pOutputText
                        type="text">

                    </td>
                    <!-- <td style="text-align: center;"  *ngIf="this.excursiondeails.is_multicost!=0">
                      <input style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].senior">
                      </td> -->
                    <td
                      *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length==0)"
                      [pEditableColumn]="product.adultprice" pEditableColumnField="adultprice">
                      <!-- <span [(ngModel)]="cost_adult=true"></span> -->
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let adx=index">
                        <ng-template *ngIf="li.paxType=='Adult'" pTemplate="input">
                          <input style="width: 95px;border: 1px solid;"
                            [disabled]="excursiondeails.supplierList[rowIndex].comp_cust==0?false:true"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,adx,rowIndex)" pInputText type="text"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Adult'?excursiondeails.supplierList[rowIndex].cost[adx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].adultprice">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Adult'" pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,adx,rowIndex)"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[adx].paxType=='Adult'?excursiondeails.supplierList[rowIndex].cost[adx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].adultprice">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].adultprice">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].adultprice">
                        </ng-template>
                      </p-cellEditor>
                      <input
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && this.excursiondeails.supplierList[rowIndex].cost_adult==false"
                        style="width: 95px;border: 1px solid;" disabled="true" pOutputText type="text">
                    </td>
                    <td
                      *ngIf="(cost_adult||cost_child||cost_senior||excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length==0)"
                      [pEditableColumn]="product.childprice" pEditableColumnField="childprice">
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let cdx=index">
                        <ng-template *ngIf="li.paxType=='Child' || li.paxType == 'Child as Adult'" pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [disabled]="excursiondeails.supplierList[rowIndex].comp_cust==0?false:true"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,cdx,rowIndex)"
                            [ngModel]="(excursiondeails.supplierList[rowIndex].cost[cdx].paxType=='Child' || excursiondeails.supplierList[rowIndex].cost[cdx].paxType == 'Child as Adult')?excursiondeails.supplierList[rowIndex].cost[cdx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].childprice">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Child' || li.paxType == 'Child as Adult'" pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,cdx,rowIndex)"
                            [ngModel]="(excursiondeails.supplierList[rowIndex].cost[cdx].paxType=='Child' || excursiondeails.supplierList[rowIndex].cost[cdx].paxType == 'Child as Adult')?excursiondeails.supplierList[rowIndex].cost[cdx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].childprice">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].childprice">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].childprice">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !this.excursiondeails.supplierList[rowIndex].cost_child"
                        style="width: 95px;border: 1px solid;" disabled="true" pOutputText type="text">
                    </td>
                    <td
                      *ngIf="this.appClient != 'RoyalPark' && ((cost_adult||cost_child||cost_senior || excursiondeails.ratebasis!='UNIT')||(excursiondeails.supplierList[rowIndex].cost.length==0))"
                      [pEditableColumn]="product.seniorprice" pEditableColumnField="seniorprice">
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost ;let sdx=index ">
                        <ng-template *ngIf="li.paxType=='Senior'" pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [disabled]="excursiondeails.supplierList[rowIndex].comp_cust==0?false:true"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,sdx,rowIndex)"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[sdx].paxType=='Senior'?excursiondeails.supplierList[rowIndex].cost[sdx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].seniorprice">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Senior'" pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,sdx,rowIndex)"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[sdx].paxType=='Senior'?excursiondeails.supplierList[rowIndex].cost[sdx].paxOrUnitRate:excursiondeails.supplierList[rowIndex].seniorprice">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].seniorprice">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].seniorprice">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !this.excursiondeails.supplierList[rowIndex].cost_senior"
                        style="width: 95px;border: 1px solid;" disabled="true" pOutputText type="text">
                    </td>
                    <td *ngIf="excursiondeails.ratebasis=='UNIT'" [pEditableColumn]="product.units"
                      pEditableColumnField="units">
                      <!-- <p-cellEditor >
                    <ng-template pTemplate="input">
                        <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].units">
                    </ng-template>
                    <ng-template pTemplate="output">
                        <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].units">
                    </ng-template>
                </p-cellEditor> -->
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost ;let sdx=index ">
                        <ng-template *ngIf="li.paxType=='Unit'" pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" disabled="true" pInputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,sdx,rowIndex)"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[sdx].paxType=='Unit'?excursiondeails.supplierList[rowIndex].cost[sdx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].units">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Unit'" pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" disabled="true" pOutputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,sdx,rowIndex)"
                            [ngModel]="excursiondeails.supplierList[rowIndex].cost[sdx].paxType=='Unit'?excursiondeails.supplierList[rowIndex].cost[sdx].noofPaxOrUnit:excursiondeails.supplierList[rowIndex].units">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" disabled="true" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].units">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" disabled="true" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].units">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !this.excursiondeails.supplierList[rowIndex].cost_unit"
                        style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text">
                      <!-- <input *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 &&(!cost_adult && !cost_child && !cost_senior)" disabled="true" style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].units"> -->
                      <!-- <span *ngFor="let li of excursiondeails.supplierList[rowIndex].cost">
                  <span *ngIf="li.paxType=='Unit'">{{let li of excursiondeails.supplierList[rowIndex].cost.noofPaxOrUnit}}</span></span>
                <span *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">{{excursiondeails.supplierList[rowIndex].units}}</span> -->
                    </td>
                    <td *ngIf="excursiondeails.ratebasis=='UNIT'" [pEditableColumn]="product.unitprice"
                      pEditableColumnField="unitprice">
                      <p-cellEditor *ngFor="let li of excursiondeails.supplierList[rowIndex].cost;let udx=index">
                        <ng-template *ngIf="li.paxType=='Unit'" pTemplate="input">
                          <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,udx,rowIndex)"
                            [ngModel]="li.paxType=='Unit'?li.paxOrUnitRate:excursiondeails.supplierList[rowIndex].unitprice">
                        </ng-template>
                        <ng-template *ngIf="li.paxType=='Unit'" pTemplate="output">
                          <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            (keypress)="numbersWithDecimalOnly($event)"
                            (input)="adultchange($event.target,udx,rowIndex)"
                            [ngModel]="li.paxType=='Unit'?li.paxOrUnitRate:excursiondeails.supplierList[rowIndex].unitprice">
                        </ng-template>
                      </p-cellEditor>
                      <p-cellEditor *ngIf="excursiondeails.supplierList[rowIndex].cost.length==0">
                        <ng-template pTemplate="input">
                          <!-- <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].unitprice"> -->
                            <input style="width: 95px;border: 1px solid;" pInputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].unitprice">
                        </ng-template>
                        <ng-template pTemplate="output">
                          <!-- <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].unitprice"> -->
                            <input style="width: 95px;border: 1px solid;" pOutputText type="text"
                            [(ngModel)]="excursiondeails.supplierList[rowIndex].unitprice">
                        </ng-template>
                      </p-cellEditor>
                      <input style="width: 95px;border: 1px solid;"
                        *ngIf="excursiondeails.supplierList[rowIndex].cost.length!=0 && !this.excursiondeails.supplierList[rowIndex].cost_unit"
                        style="width: 50px;border: 1px solid;" disabled="true" pOutputText type="text">
                    </td>
                    <!-- <td [pEditableColumn]="product.comp_cust" pEditableColumnField="comp_cust">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].comp_cust">
                    </ng-template>
                    <ng-template pTemplate="output">
                        <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="excursiondeails.supplierList[rowIndex].comp_cust">
                    </ng-template>
                </p-cellEditor>
            </td> -->

                    <!-- <td>{{product.child}}</td> -->
                    <!-- <td>{{product.senior}}</td> -->
                    <!-- <td>{{product.adultprice}}</td> -->
                    <!-- <td>{{product.childprice}}</td> -->
                    <!-- <td>{{product.seniorprice}}</td> -->
                    <!-- <td>{{product.comp_cust}}</td> -->
                    <!-- <td>{{product.service_status}}</td> -->

                    <td><span>
                        {{getSum(excursiondeails.supplierList[rowIndex].cost,rowIndex)}}
                      </span></td>
                    <!-- excursiondeails.ratebasis!='UNIT' condition added by Ram 10-07-2023 -->
                    <!-- this.excursiondeails.is_multidate == 0 condition added by Ram 30-05-2024 -->
                    <td
                      *ngIf="excursiondeails.ratebasis != 'UNIT' && this.excursiondeails.is_multicost == 0 && this.excursiondeails.is_multidate == 0 && !excursiondeails.supplierList[rowIndex].hasOwnProperty('close')&& excursiondeails.supplierList[rowIndex].service_id!=0 && (excursiondeails.supplierList[rowIndex].rownumber==1||!excursiondeails.supplierList[rowIndex].hasOwnProperty('rownumber'))">
                      <i (click)="add_row(excursiondeails.supplierList[rowIndex],rowIndex)" class="pi pi-plus"></i>
                    </td>
                    <td
                      *ngIf="excursiondeails.supplierList[rowIndex].service_id==0 && !excursiondeails.supplierList[rowIndex].hasOwnProperty('close')">



                    </td>
                    <td
                      *ngIf="(excursiondeails.supplierList[rowIndex].cost.length!=0? (excursiondeails.supplierList[rowIndex].cost[0].paxType!='Child' && excursiondeails.supplierList[rowIndex].cost[0].paxType!='Child as Adult'):true) &&(this.excursiondeails.is_multicost==0 && excursiondeails.supplierList[rowIndex].hasOwnProperty('close') || (excursiondeails.supplierList[rowIndex].rownumber>1))">

                      <i (click)="close_row(excursiondeails.supplierList[rowIndex],rowIndex)" class="pi pi-times"></i>
                    </td>
                    <td
                      *ngIf="excursiondeails.supplierList[rowIndex].service_id==0 && !excursiondeails.supplierList[rowIndex].hasOwnProperty('close')">



                    </td>
                    <td
                      *ngIf="excursiondeails.supplierList[rowIndex].service_id!=0 &&(excursiondeails.supplierList[rowIndex].rownumber==1||!excursiondeails.supplierList[rowIndex].hasOwnProperty('rownumber')) ||this.excursiondeails.is_multicost!=0">
                      <button (click)="save_row_data(excursiondeails.supplierList[rowIndex],rowIndex)"
                        class="primary-default-btn">Save</button>
                    </td>
                    <td *ngIf="this.appClient != 'RoyalAdventure'">
                      &nbsp;
                    </td>
                    <td *ngIf="this.appClient == 'RoyalAdventure'">
                      <button (click)="redirect_email(excursiondeails.supplierList[rowIndex], rowIndex)" class="primary-default-btn">Email</button>
                    </td>
                    <!-- <td>{{product.service_status}}</td>
                      <td ><button class="primary-default-btn">Views</button></td> -->
                  </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-product let-rowIndex="rowIndex" let-rowData
                  let-columns="columns">
                  <tr>
                    <td [attr.colspan]="[rowData['ratebasis']=='UNIT'?11:13]">
                      <div class="p-p-3">
                        <p-table styleClass="p-datatable-striped" [value]="[excursiondeails.supplierList[rowIndex]]"
                          dataKey="service_id">
                          <ng-template pTemplate="header">
                  <tr *ngIf="rowData['service_id']==excursiondeails.supplierList[rowIndex].service_id">
                    <th style="width: 3rem"></th>
                    <th>Critical</th>
                    <th></th>
                    <th>Comp </th>
                    <th>Status </th>
                    <th style="max-width: 180px;">Notifications </th>
                    <th>Supplier Remarks</th>


                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-order>
                  <tr *ngIf="rowData['service_id']==excursiondeails.supplierList[rowIndex].service_id">
                    <td></td>
                    <td style="min-width: 80px;max-width: 80px;"
                      [pEditableColumn]="excursiondeails.supplierList[rowIndex]['criticality']"
                      pEditableColumnField="rowData['criticality']">
                      <!-- <p-cellEditor>
                                      <ng-template pTemplate="input"> -->
                      <ng-select [searchable]="false" [items]="critical_list" bindLabel="value" bindValue="id"
                        [disabled]="excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType=='Child':false"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex]['criticality']">
                      </ng-select>

                      <!-- <p-dropdown  [options]="critical_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['criticality']" optionLabel="value" optionValue="id"  [showClear]="true" placeholder="Select Criticality">
                                       
                                         
                                      </p-dropdown> -->
                      <!-- <ng-select 
                                        [items]="critical_list"
                                        bindLabel="value"
                                        bindValue="id"
                                        [virtualScroll]="true"
                                        dropdownPosition="top"
                                        [(ngModel)]="excursiondeails.supplierList[rowIndex]['criticality']"
                                        
                                                             
                                        > -->
                      <!-- <input [(ngModel)]="+excursiondeails.supplierList[rowIndex].criticality" type="checkbox"/> -->
                      <!-- <p-triStateCheckbox [(ngModel)]="excursiondeails.supplierList[rowIndex].criticality" [label]="excursiondeails.supplierList[rowIndex].criticality"></p-triStateCheckbox> -->
                      <!-- </ng-select> -->
                      <!-- <p-dropdown [options]="supplier_list" [(ngModel)]="product.service_provider" optionLabel="partyname" optionValue="partycode"></p-dropdown> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                      <ng-template pTemplate="output">
                                        <p-dropdown  [options]="critical_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['criticality']" optionLabel="value" optionValue="id"  [showClear]="true" placeholder="Select Criticality">
                                       
                                         
                                        </p-dropdown> -->
                      <!-- <ng-select 
                                        [items]="critical_list"
                                        bindLabel="value"
                                        bindValue="id"
                                        [virtualScroll]="true"
                                        dropdownPosition="top"
                                        [(ngModel)]="excursiondeails.supplierList[rowIndex]['criticality']"
                                                              
                                        >
                              </ng-select> -->
                      <!-- <input checked="excursiondeails.supplierList[rowIndex].criticality == '0'" [(ngModel)]="+excursiondeails.supplierList[rowIndex].criticality" type="checkbox"/> -->
                      <!-- <p-triStateCheckbox [(ngModel)]="excursiondeails.supplierList[rowIndex].criticality" [label]="excursiondeails.supplierList[rowIndex].criticality"></p-triStateCheckbox> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                  </p-cellEditor> -->
                    </td>
                    <td></td>
                    <td style="min-width: 80px;max-width: 80px;"
                      [pEditableColumn]="excursiondeails.supplierList[rowIndex]['comp_cust']"
                      pEditableColumnField="rowData['comp_cust']">
                      <!-- <p-cellEditor>
                                        <ng-template pTemplate="input"> -->
                      <ng-select [searchable]="false" [items]="comp_list" bindLabel="value" bindValue="id"
                        (change)="compensation_change($event,rowIndex)"
                        [disabled]="excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType=='Child':false"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex].comp_cust">
                      </ng-select>
                      <!-- <p-dropdown  [options]="comp_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['comp_cust']" optionLabel="value" optionValue="id"  [showClear]="true" placeholder="Select Comp">
                                       
                                         
                                          </p-dropdown> -->
                      <!-- <ng-select 
                                          [items]="comp_list"
                                          bindLabel="value"
                                          bindValue="id"
                                          [virtualScroll]="true"
                                          [clearable]="false"
                                          dropdownPosition="top"
                                          [(ngModel)]="excursiondeails.supplierList[rowIndex]['comp_cust']"
                                                               
                                          >
                                </ng-select> -->
                      <!-- <p-dropdown [options]="supplier_list" [(ngModel)]="product.service_provider" optionLabel="partyname" optionValue="partycode"></p-dropdown> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                        <ng-template pTemplate="output">
                                          <p-dropdown  [options]="comp_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['comp_cust']" optionLabel="value" optionValue="id"  [showClear]="true" placeholder="Select Comp">
                                       
                                         
                                          </p-dropdown> -->
                      <!-- <ng-select 
                                          [items]="comp_list"
                                          bindLabel="value"
                                          bindValue="id"
                                          [virtualScroll]="true"
                                          [clearable]="false"
                                          dropdownPosition="top"
                                          [(ngModel)]="excursiondeails.supplierList[rowIndex]['comp_cust']"
                                                                
                                          >
                                </ng-select> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                    </p-cellEditor> -->
                    </td>
                    <td style="min-width: 150px;max-width: 150px;"
                      [pEditableColumn]="excursiondeails.supplierList[rowIndex]['serviceStatus']"
                      pEditableColumnField="rowData['serviceStatus']">
                      <!-- <p-cellEditor>
                                          <ng-template pTemplate="input"> -->
                      <ng-select [searchable]="false" [items]="status_list" bindLabel="value" bindValue="id"
                        [disabled]="excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType=='Child':false"
                        (open)="remove_list(rowIndex)" (close)="close_status()" (change)="statcsChange($event,rowIndex)"
                        [(ngModel)]="excursiondeails.supplierList[rowIndex].serviceStatus">
                      </ng-select>
                      <!-- <p-dropdown  [options]="status_list"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['serviceStatus']" optionLabel="value" optionValue="id"  placeholder="Select Status">
                                       
                                         
                                            </p-dropdown> -->
                      <!-- <ng-select 
                                            [items]="status_list"
                                            bindLabel="value"
                                            bindValue="id"
                                            [virtualScroll]="true"
                                            dropdownPosition="top"
                                            [(ngModel)]="excursiondeails.supplierList[rowIndex]['serviceStatus']"
                                                                 
                                            >
                                  </ng-select> -->
                      <!-- <p-dropdown [options]="supplier_list" [(ngModel)]="product.service_provider" optionLabel="partyname" optionValue="partycode"></p-dropdown> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                          <ng-template pTemplate="output">
                                            <p-dropdown  [options]="status_list" [style]="{'width':'100%'}"  [(ngModel)]="excursiondeails.supplierList[rowIndex]['serviceStatus']" optionLabel="value" optionValue="id"  [showClear]="true" placeholder="Select Status">
                                       
                                         
                                            </p-dropdown> -->
                      <!-- <ng-select 
                                            [items]="status_list"
                                            bindLabel="value"
                                            bindValue="id"
                                            [virtualScroll]="true"
                                            dropdownPosition="top"
                                            [(ngModel)]="excursiondeails.supplierList[rowIndex]['serviceStatus']"
                                                                  
                                            >
                                  </ng-select> -->
                      <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.adults"> -->
                      <!-- </ng-template>
                                      </p-cellEditor> -->
                    </td>

                    <td style="min-width:150px;max-width:150px;">

                      <ng-select [searchable]="false" [items]="notification_list" bindLabel="value" bindValue="id"
                        [disabled]="excursiondeails.supplierList[rowIndex].cost.length!=0?excursiondeails.supplierList[rowIndex].cost[0].paxType=='Child':false"
                        [(ngModel)]="rowData['notification_li']">
                      </ng-select>

                    </td>
                    <td [pEditableColumn]="rowData['coments']" pEditableColumnField="coments">
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <textarea maxlength="400" pInputText type="text" [(ngModel)]="rowData['coments']" rows="4"
                            cols="20" wrap="hard">
                                            </textarea>
                          <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                        </ng-template>
                        <ng-template pTemplate="output">
                          <textarea maxlength="400" style="width: 110px;height: 37px;" pOutputText type="text"
                            [(ngModel)]="rowData['coments']" rows="4" cols="20" wrap="hard">

                                            </textarea>
                          <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                        </ng-template>
                      </p-cellEditor>
                    </td>


                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6">There are no order for this product yet.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            </td>
            </tr>
            </ng-template>
            </p-table>
            <p-table *ngIf="menutitle=='location'" scrollHeight="50vh" [value]="location_list" [loading]="loading"
              styleClass="p-datatable-striped" responsiveLayout="stack">
              <!-- <ng-template pTemplate="caption">
                Default
            </ng-template> -->
              <ng-template pTemplate="header" let-columns>
                <tr>

                  <th>Service Date</th>
                  <th>Service Name</th>
                  <th>Pickup Location</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Pickup Time</th>
                  <th>DropOff Time</th>
                  <th></th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-product let-columns="columns">
                <tr
                  *ngIf="product.is_parent!=1 || (this.excursiondeails.is_multicost==0 && this.excursiondeails.supplierList.length!=0)">
                  <td *ngIf="product.excdate.length<11">{{product.excdate }}</td>
                  <td *ngIf="product.excdate.length>10">{{product.excdate | date: 'dd-MM-yyyy'}}</td>
                  <td>{{product.service_name}}</td>

                  <td [pEditableColumn]="product.location" pEditableColumnField="location">
                    <!-- <p-cellEditor>
                        <ng-template pTemplate="input"> -->
                    <!-- <ng-autocomplete 
                          [(ngModel)]="location_list[rowIndex].location"
                    [data]="locations"
                    [searchKeyword]="keyword"
                    (keyup)="searchlocation($event.target)"
                    historyIdentifier="locations"
                    placeholder="Select country"
                    
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate">                                 
                  </ng-autocomplete> -->

                    <!-- <ng-select  [style]="{'width':'250px','margin': '0 auto;'}" 
                  (keyup)="searchlocation($event.target)"
                  [items]="locations"
                  bindLabel="partyname"
                  bindValue="partyname"
                  
                  [(ngModel)]="location_list[rowIndex]['location']"                               
                  ></ng-select> -->

                    <p-dropdown [(ngModel)]="location_list[rowIndex]['location']" [options]="locations"
                      (keyup)="searchlocation($event.target)" optionValue="partyname" [editable]="true"
                      optionLabel="partyname"></p-dropdown>

                    <!-- <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.partyname"></a>
                  </ng-template>
                  
                  <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                  </ng-template> -->

                    <!-- <textarea pInputTextarea pInputText type="text" [(ngModel)]="location_list[rowIndex].location" rows="4" cols="50">
                            </textarea> -->
                    <!-- <textarea pInputTextarea [(ngModel)]="property"></textarea> -->
                    <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                    <!-- </ng-template>
                        <ng-template pTemplate="output">
                          <ng-select 
                  (keyup)="searchlocation($event.target)"
                  [items]="locations"
                  bindLabel="partyname"
                  bindValue="partycode"
                  autofocus
                  [(ngModel)]="location_list[rowIndex].location"                               
                  ></ng-select> -->
                    <!-- <ng-autocomplete 
                          [(ngModel)]="location_list[rowIndex].location"
                    [data]="locations"
                    [searchKeyword]="keyword"
                    (keyup)="searchlocation($event.target)"
                    historyIdentifier="locations"
                    placeholder="Select Location"
                  
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate">                                 
                  </ng-autocomplete>
                  
                  <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.partyname"></a>
                  </ng-template>
                  
                  <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div> -->
                    <!-- </ng-template> -->
                    <!-- </textarea> -->
                    <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                    <!-- </ng-template>
                    </p-cellEditor> -->
                  </td>
                  <!-- <td [pEditableColumn]="location_list[rowIndex].location" pEditableColumnField="location">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input style="width: 50px;border: 1px solid;" pInputText type="text" [(ngModel)]="location_list[rowIndex].location">
                    </ng-template>
                    <ng-template pTemplate="output">
                        <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="location_list[rowIndex].location">
                    </ng-template>
                </p-cellEditor>
              </td> -->
                  <td [pEditableColumn]="product.exc_starttime" pEditableColumnField="exc_starttime">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input type="text" (keypress)="numberOnly($event)" placeholder="HH:mm" pInputText
                          (keyup)="nuberchange($event)" style="width: 90px;border: 1px solid;"
                          [(ngModel)]="product.exc_starttime">
                        <!-- <input type="time" pInputText style="width: 90px;border: 1px solid;" format="24"  [(ngModel)]="product.exc_starttime"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <input type="text" style="width: 90px;border: 1px solid;" pOutputText placeholder="HH:mm"
                          [(ngModel)]="product.exc_starttime">
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="product.exc_endtime" pEditableColumnField="exc_endtime">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input style="width: 90px;border: 1px solid;" placeholder="HH:mm" pInputText type="text"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.exc_endtime">
                        <!-- <input  style="width: 90px;border: 1px solid;" pInputText type="time" format="HH:mm" [(ngModel)]="product.exc_endtime"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <input style="width: 90px;border: 1px solid;" pOutputText placeholder="HH:mm" type="text"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.exc_endtime">
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="product.pickup_time" pEditableColumnField="pickup_time">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input style="width: 90px;border: 1px solid;" placeholder="HH:mm" pInputText type="text"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.pickup_time">
                        <!-- <input  style="width: 90px;border: 1px solid;" pInputText type="time" format="HH:mm" [(ngModel)]="product.pickup_time"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <input style="width: 90px;border: 1px solid;" pOutputText placeholder="HH:mm" type="text"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.pickup_time">
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <td [pEditableColumn]="product.drop_offtime" pEditableColumnField="drop_offtime">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input style="width: 90px;border: 1px solid;" pInputText type="text" placeholder="HH:mm"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.drop_offtime">
                        <!-- <input  style="width: 90px;border: 1px solid;" pInputText type="time" format="HH:mm" [(ngModel)]="product.drop_offtime"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <input style="width: 90px;border: 1px solid;" pOutputText type="text" placeholder="HH:mm"
                          (keypress)="numberOnly($event)" (keyup)="nuberchange($event)"
                          [(ngModel)]="product.drop_offtime">
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td style="text-align: end;background-color: #ffffff"><p-button (click)="savelocation(product)"
                      label="Save" class="p-button-text"></p-button></td>
                </tr>
              </ng-template>
              <!-- <ng-template let-product pTemplate="footer">
            <tr>
              <td style="background-color: #ffffff;"></td>
              <td style="background-color: #ffffff;"></td>
              <td style="background-color: #ffffff;"></td>
              <td style="background-color: #ffffff;"></td>
              <td style="background-color: #ffffff;"></td>
              <td style="background-color: #ffffff;"></td>
              <td style="text-align: end;background-color: #ffffff"><p-button (click)="savelocation(product)" label="Save" class="p-button-text"></p-button></td>
            </tr>
            
        </ng-template> -->
            </p-table>
            <p-table *ngIf="menutitle=='remarks'" scrollHeight="50vh" [value]="remarks_list" [loading]="loading"
              styleClass="p-datatable-striped" responsiveLayout="stack">
              <!-- <ng-template pTemplate="caption">
                Default
            </ng-template> -->
              <ng-template pTemplate="header" let-columns>
                <tr>

                  <th>Service Date</th>
                  <th>Service Name</th>
                  <th>Supplier Remarks</th>
                  <th>Customer Remarks</th>
                  <th>Arrival Remarks</th>
                  <th>Departure Remarks</th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-product let-columns="columns">
                <tr>

                  <td *ngIf="remarks_list[rowIndex].excdate.length>10">{{remarks_list[rowIndex].excdate | date:
                    'dd-MM-yyyy'}}</td>
                  <td *ngIf="remarks_list[rowIndex].excdate.length<11">{{remarks_list[rowIndex].excdate}}</td>
                  <td>{{remarks_list[rowIndex].service_name}}</td>


                  <td [pEditableColumn]="remarks_list[rowIndex].Partyremarks" pEditableColumnField="Partyremarks">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea maxlength="400" pInputText pInputTextarea
                          [(ngModel)]="remarks_list[rowIndex].Partyremarks" rows="4" cols="20" wrap="hard">
                          </textarea>
                        <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <textarea maxlength="400" pOutputText pInputTextarea
                          [(ngModel)]="remarks_list[rowIndex].Partyremarks" rows="4" cols="20" wrap="hard">

                          </textarea>
                        <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="remarks_list[rowIndex].agentremarks" pEditableColumnField="agentremarks">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea maxlength="400" pInputTextarea pInputText type="text"
                          [(ngModel)]="remarks_list[rowIndex].agentremarks" rows="4" cols="20" wrap="hard">
                        </textarea>
                        <!-- <textarea pInputTextarea [(ngModel)]="property"></textarea> -->
                        <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <textarea maxlength="400" pInputTextarea pOutputText type="text"
                          [(ngModel)]="remarks_list[rowIndex].agentremarks" rows="4" cols="20" wrap="hard">

                        </textarea>
                        <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="product.arrivalremarks" pEditableColumnField="arrivalremarks">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea maxlength="400" pInputText pInputTextarea
                          [(ngModel)]="remarks_list[rowIndex].arrivalremarks" rows="4" cols="20" wrap="hard">
                        </textarea>
                        <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <textarea maxlength="400" pOutputText pInputTextarea
                          [(ngModel)]="remarks_list[rowIndex].arrivalremarks" rows="4" cols="20" wrap="hard">

                        </textarea>
                        <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <td [pEditableColumn]="product.departureremarks" pEditableColumnField="coments">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea maxlength="400" pInputText pInputTextarea
                          [(ngModel)]="remarks_list[rowIndex].departureremarks" rows="4" cols="20" wrap="hard">
                  </textarea>
                        <!-- <input style="width: 100px;border: 1px solid;" pInputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                      <ng-template pTemplate="output">
                        <textarea maxlength="400" pInputTextarea pOutputText type="text"
                          [(ngModel)]="remarks_list[rowIndex].departureremarks" rows="4" cols="20" wrap="hard">

                  </textarea>
                        <!-- <input style="width: 50px;border: 1px solid;" pOutputText type="text" [(ngModel)]="product.coments"> -->
                      </ng-template>
                    </p-cellEditor>
                  </td>

                </tr>
              </ng-template>
              <ng-template pTemplate="footer" let-rowIndex="rowIndex">
                <tr>
                  <td style="background-color: #ffffff;">{{rowIndex}}</td>
                  <td style="background-color: #ffffff;"></td>
                  <td style="background-color: #ffffff;"></td>
                  <td style="background-color: #ffffff;"></td>
                  <td style="background-color: #ffffff;"></td>
                  <td style="text-align: end;background-color: #ffffff">
                    <p-button (click)="saveremarks(remarks_list[0])" label="Save" class="p-button-text"></p-button>
                  </td>
                </tr>

              </ng-template>
            </p-table>



            <p-table *ngIf="menutitle=='confirmations'" scrollHeight="50vh" [value]="confirmation_list"
              [loading]="loading" styleClass="p-datatable-striped" responsiveLayout="stack">
              <!-- <ng-template pTemplate="caption">
              Default
          </ng-template> -->
              <ng-template pTemplate="header" let-columns>
                <tr>

                  <th>Request Id</th>
                  <th>Service Date</th>
                  <th>Service Name</th>
                  <th>Supplier Name</th>
                  <th>Confirmation Id</th>
                  <th>File Attachment</th>
                  <th></th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-product let-columns="columns">
                <tr *ngIf="product.is_parent!=1 || product.is_multicost==0">
                  <td>{{product.requestid}}</td>
                  <!-- <td>{{product.excdate}}</td> -->
                  <td *ngIf="product.excdate.length<11">{{product.excdate}}</td>
                  <td *ngIf="product.excdate.length>10">{{product.excdate | date: 'dd-MM-yyyy'}}</td>
                  <td>{{product.service_name}}</td>

                  <td>{{product.sp_name}}</td>
                  <!-- <td>{{product.confirmation_id}}</td> -->
                  <td [pEditableColumn]="product.confirmation_id" pEditableColumnField="confirmation_id">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input style="width: 200px;border: 1px solid;" pInputText type="text"
                          [(ngModel)]="confirmation_list[rowIndex].confirmation_id">
                      </ng-template>
                      <ng-template pTemplate="output">
                        <input style="width: 200px;border: 1px solid;" pOutputText type="text"
                          [(ngModel)]="confirmation_list[rowIndex].confirmation_id">
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <input type="file" style="margin: 0 auto" (change)="filechange($event,rowIndex)"
                      [(ngModel)]="filechage" data-max-size="42154" class="form-control-file"
                      id="exampleFormControlFile1">
                    <span>*Only allow 5 MB FIles</span>
                  </td>

                  <td style="text-align: end;background-color: #ffffff"><p-button
                      (click)="savefile_confirmation(confirmation_list[rowIndex])" label="Save"
                      class="p-button-text"></p-button></td>

                </tr>
              </ng-template>
              <!-- <ng-template pTemplate="footer">
          <tr>
            <td style="background-color: #ffffff;"></td>
            <td style="background-color: #ffffff;"></td>
            <td style="background-color: #ffffff;"></td>
            <td style="background-color: #ffffff;"></td>
            <td style="background-color: #ffffff;"></td>
            <td style="text-align: end;background-color: #ffffff"><p-button (click)="saveremarks(excursiondeails.remarks[0])" label="Save" class="p-button-text"></p-button></td>
          </tr>
          
      </ng-template> -->
            </p-table>



            <p-table *ngIf="menutitle=='history'" scrollHeight="50vh" [value]="amend_history" [loading]="loading"
              styleClass="p-datatable-striped" responsiveLayout="stack">
              <!-- <ng-template pTemplate="caption">
            Default
        </ng-template> -->
              <ng-template pTemplate="header" let-columns>
                <tr>

                  <th>Sl.NO</th>
                  <th>Service Details</th>
                  <th>Guest Info</th>
                  <th>Service Date & Timing</th>
                  <th>Amend Date & Type</th>


                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-product let-columns="columns">
                <tr>
                  <td>{{rowIndex+1}}</td>
                  <td>{{product.service_name}}{{product.requestid}}-{{product.elineno}}</td>
                  <td>adult:{{product.adults}},child:{{product.child}},senior:{{product.senior}}units:{{product.units}}
                  </td>
                  <td>{{product.excdate}}Start time:{{product.exc_starttime}}End time:{{product.exc_endtime}}</td>
                  <td>{{product.action}}{{product.action_date}}</td>





                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td>
                    No records found
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-template>
            </p-table>

          </div>
        </div>

    </div>
    <!-- <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="displayPosition=false" label="Yes" class="p-button-text"></p-button>
            <p-button icon="pi pi-times" (click)="displayPosition=false" label="No"></p-button>
        </ng-template> -->
    </p-dialog>
    <p-dialog [style]="{width: '40%'}" header="Cost Info" [(visible)]="cost_display">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Total Booking Sale: </label>
            <span>{{this.excursiondeails.totalbookingsale | number:'1.2-2'}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Total Booking Cost: </label>
            <span>{{this.excursiondeails.totalbookingcost | number:'1.2-2'}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Total Booking Profit: </label>
            <span>{{this.excursiondeails.totalbookingprofit | number:'1.2-2'}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Total Booking Profit %: </label>
            <span>{{this.excursiondeails.totalbookingprofitperc | number:'1.2-2'}}</span>
          </div>
        </div>
      </div>
    </p-dialog>

    <p-dialog [style]="{width: '40%'}" header="" [(visible)]="CopyDetails">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Request Id : </label>
            <span>{{this.CopyDetailsData.requestid}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Guest Name : </label>
            <span>{{this.CopyDetailsData.guestname}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Pick up Location : </label>
            <span>{{this.CopyDetailsData.Location}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Room : </label>
            <span>{{this.CopyDetailsData.roomno}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Adult/Child : </label>
            <span>{{this.CopyDetailsData.adults}} / {{this.CopyDetailsData.child}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Unit : </label>
            <span>{{this.CopyDetailsData.units}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Excursion Name : </label>
            <span>{{this.CopyDetailsData.servicelist}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Excursion Date : </label>
            <span>{{this.CopyDetailsData.excdate | date: 'dd-MM-yyyy'}}</span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <label class="form-label" for="name">Remarks : </label>
            <span>{{this.CopyDetailsData.agentremarks}}</span>
          </div>
        </div>
        <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div class="col-12">
            <button (click)="CopyDetailsClick(this.CopyDetailsData)"
              class="primary-default-btn">Copy</button>
          </div>
        </div> -->
        <!-- <input #copyInput type="text" [style]="{display: 'none'}" [value]="CopyText"> -->
      </div>
    </p-dialog>
  </div>

  </div>
</main>